// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__3hE__","menuAnimation":"Menu_menuAnimation__1aD-S","item":"Menu_item__3Qm_R"};